import { Component } from "react";
import { connect } from "react-redux";
import { CalculatePriceWorker } from "../../../../../../helper/worker/CalculatePriceWorker";

class App extends Component {
  componentDidUpdate() {}

  componentWillReceiveProps(nextProps) {
    if((nextProps.price.price !== this.props.price.price) || (nextProps.operatorChanged !== this.props.operatorChanged)){
      CalculatePriceWorker(
  {
    customerType:nextProps.person ? "individual" :"business",
    serviceactiveVehicleType: nextProps.serviceactiveVehicleType,
    serviceoptions: nextProps.serviceoptions,
    pickup: {
      address: nextProps.pickup.address,
    },
    pickupadresss_loc: nextProps.pickupadresss_loc,
    firstDropOff: {
      address: nextProps.firstDropOff.address,
    },
    firstDropOffadresss_loc: nextProps.firstDropOffadresss_loc,
  },
  this.props.dispatch ,true
);
  }
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  person: state.EditOrder.editOrder.customer.person,
  operatorChanged: state.EditOrder.operatorChanged,
  paymentMethod: state.EditOrder.paymentMethod,
  price: state.EditOrder.editOrder.price,
  serviceactiveVehicleType: state.EditOrder.editOrder.service.activeVehicleType,
  serviceoptions: state.EditOrder.editOrder.service.options,
  pickup: state.EditOrder.editOrder.pickup,
  pickupadresss_loc: state.EditOrder.editOrder.pickup.adresss_loc,
  firstDropOff: state.EditOrder.editOrder.dropOffs.firstDropOff,
  firstDropOffadresss_loc:
    state.EditOrder.editOrder.dropOffs.firstDropOff.adresss_loc,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
